import { render, staticRenderFns } from "./OrdersHeatMap.vue?vue&type=template&id=19934d9c&scoped=true"
import script from "./OrdersHeatMap.vue?vue&type=script&lang=js"
export * from "./OrdersHeatMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19934d9c",
  null
  
)

export default component.exports